import { createContext } from "react";
import { Client } from "../../../../types/global";

export const ClientsContext = createContext<Array<Client>>([])